

import icons from "url:../../img/icons.svg";


class View {
    _data;

    /**
     * Renders the received object to the DOM using a parent element (_parentEl)
     * that is specified inside child classes that extend the View class.
     * @param {Object | Object[]} data The data to be rendered (e.g. recipe)
     * @returns {undefined}
     * @this {Object} View instance
     */
    render(data) {
        if (!data || Array.isArray(data) && data.length === 0) {
            return this.renderErrorMessage();
        }
        this._data = data;
        this._clearHTML();
        this._parentEl.insertAdjacentHTML("afterbegin", this._generateMarkup());
    }


    update(data) {
        this._data = data;

        const markup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(markup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentEl.querySelectorAll("*"));

        newElements.forEach((newElem, i) => {
            const curElem = curElements[i];

            if (newElem.isEqualNode(curElem)) return;
            
            curElem.innerHTML = newElem.innerHTML;
        });
    }


    renderSpinner() {
        const markup = `
            <div class="spinner">
                <svg>
                    <use href="${icons}#icon-loader"></use>
                </svg>
            </div>`;
        
        this._clearHTML();
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
    }


    renderErrorMessage(message = this._errorMessage) {
        const markup = 
            `<div class="error">
                <div>
                    <svg>
                        <use href="${icons}#icon-alert-triangle"></use>
                    </svg>
                </div>
                <p>${message}</p>
            </div>`;
            
        this._clearHTML();
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
    }


    renderSuccessMessage(message = this._successMessage) {
        const markup = 
        `<div class="message">
            <div>
                <svg>
                    <use href="${icons}#icon-smile"></use>
                </svg>
            </div>
            <p>${message}</p>
        </div>`;
        
        this._clearHTML();
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
    }


    _clearHTML() {
        this._parentEl.innerHTML = "";
    }


    _doDataExist(data) {
        if (!data || Array.isArray(data) && data.length === 0) {
            return false;
        }
    }
}

export default View;